import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { axios } from '@/config/plugins/axios';

import { supportedLanguages } from '@/translations';
import { default as fallbackLangMessages } from '@/translations/fr';

Vue.use(VueI18n);

const FALLBACK_LANG = 'fr';

let defaultLang = window.localStorage.getItem('lang') || FALLBACK_LANG;

if (!supportedLanguages.includes(defaultLang)) {
	defaultLang = FALLBACK_LANG;
}

export const i18n = new VueI18n({
	locale: defaultLang,
	fallbackLocale: FALLBACK_LANG
});

i18n.setLocaleMessage(FALLBACK_LANG, fallbackLangMessages);

const loadedLanguages = [FALLBACK_LANG];

function setI18nLanguage(lang: string): string {
	i18n.locale = lang;
	axios.defaults.headers.common['Accept-Language'] = lang;
	window.localStorage.setItem('lang', lang);

	const html = document.querySelector('html');

	if (html) {
		html.setAttribute('lang', lang);
	}

	return lang;
}

export async function loadLanguageAsync(lang: string): Promise<string> {
	if (i18n.locale === lang) {
		return Promise.resolve(setI18nLanguage(lang));
	}

	if (loadedLanguages.includes(lang)) {
		return Promise.resolve(setI18nLanguage(lang));
	}

	if (!supportedLanguages.includes(lang)) {
		return Promise.reject(lang);
	}

	const messages = await import(/* webpackChunkName: "translations-[request]" */ `@/translations/${lang}`);
	i18n.setLocaleMessage(lang, messages.default);
	loadedLanguages.push(lang);

	return setI18nLanguage(lang);
}
